import { render, staticRenderFns } from "./InfoPlaystationStore.vue?vue&type=template&id=74cadc94"
import script from "./InfoPlaystationStore.vue?vue&type=script&lang=js"
export * from "./InfoPlaystationStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports